export default class ListingSearchDataParams {
  constructor (url) {
    this.url = url
  }

  get queryString () {
    return this.splitStringAndTake(this.url, '?', 1).split('&')
  }

  get params () {
    return this.queryString.map(part => ({
      key: this.splitStringAndTake(part, '=', 0),
      value: this.splitStringAndTake(part, '=', 1),
    }))
  }

  /**
   * 
   * @param {String} url part with query string
   * @param {*} char character to split up
   * @param {*} part of divided string to return
   * @returns query string part
   */
  splitStringAndTake (url, char, part) {
    return url.split(char)[part]
  }
}


// WEBPACK FOOTER //
// ./src/modules/search/ListingSearchDataParams.js